<table
	class="w-100"
	mat-table
	[dataSource]="assignmentDataSource"
	matSort
	matSortDisableClear
	#employeeSort="matSort"
	matSortDirection="asc"
	matSortActive="lastName"
	[class.d-none]="!assignmentDataSource?.data?.length"
>
	<!-- //NOSONAR -->
	<ng-container matColumnDef="select">
		<th mat-header-cell *matHeaderCellDef>
			<mat-checkbox
				(change)="$event ? selectAllEmployeesToggle() : null"
				[checked]="selection.hasValue() && selection.selected.length === assignmentDataSource.data.length"
				[indeterminate]="selection.hasValue() && selection.selected.length !== assignmentDataSource.data.length"
			>
			</mat-checkbox>
		</th>
		<td mat-cell *matCellDef="let row">
			<mat-checkbox
				(click)="$event.stopPropagation()"
				(change)="onChange($event, row)"
				[checked]="selection.isSelected(row)"
			>
			</mat-checkbox>
		</td>
	</ng-container>
	<ng-container matColumnDef="firstName">
		<th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _lang("firstname") }}</th>
		<td mat-cell *matCellDef="let row">
			{{ row.employee.firstName }}
		</td>
	</ng-container>
	<ng-container matColumnDef="lastName">
		<th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _lang("lastname") }}</th>
		<td mat-cell *matCellDef="let row">
			{{ row.employee.lastName }}
		</td>
	</ng-container>
	<ng-container matColumnDef="effectiveFrom">
		<th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _lang("from") }}</th>
		<td mat-cell *matCellDef="let row">
			<!-- {{row.effectiveFrom | date:'dd.MM.yyyy'}}-->
			<mat-form-field class="tableForm lessPadding">
				<input
					matInput
					(dateChange)="
						row.effectiveFrom.setValue($event.value ? $event.value.format('YYYY-MM-DD') : '');
						onEffectiveFromChange(row);
						row.effectiveUntil.updateValueAndValidity()
					"
					appOnlyNumbers
					[matDatepicker]="pickerFrom"
					autocomplete="off"
					[formControl]="row.effectiveFrom"
				/>
				<mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
				<mat-datepicker #pickerFrom></mat-datepicker>
				@if (row.effectiveFrom.errors?.assignmentOutsideProjectBounds) {
					<mat-error>{{ _lang("error.assignment-out-of-project-bounds") }}</mat-error>
				}
				@if (getOverlappingAssignment(row.effectiveFrom, row); as overlappingAssignment) {
					<mat-hint align="end" class="assignment-warning">
						{{ _lang("error.overlapping-assignment") }}<br />
						{{ overlappingAssignment.effectiveFrom | date: "dd.MM.yyyy" }}
						- {{ overlappingAssignment.effectiveUntil | date: "dd.MM.yyyy" }}
					</mat-hint>
				}
			</mat-form-field>
		</td>
	</ng-container>
	<ng-container matColumnDef="effectiveUntil">
		<th mat-header-cell mat-sort-header *matHeaderCellDef>{{ _lang("until") }}</th>
		<td mat-cell *matCellDef="let row">
			<mat-form-field class="tableForm lessPadding">
				<input
					matInput
					(dateChange)="
					row.effectiveUntil.setValue($event.value ? $event.value.format('YYYY-MM-DD') : '');
					onEffectiveUntilChange(row)
					"
					appOnlyNumbers
					[matDatepicker]="pickerUntil"
					autocomplete="off"
					[formControl]="row.effectiveUntil"
				/>
				<mat-datepicker-toggle matSuffix [for]="pickerUntil"></mat-datepicker-toggle>
				<mat-datepicker #pickerUntil></mat-datepicker>
				@if (row.effectiveUntil.errors?.untilBeforeFrom) {
					<mat-error>{{ _lang("error.assignment-end-before-start") }}</mat-error>
				}
				@if (row.effectiveUntil.errors?.assignmentOutsideProjectBounds) {
					<mat-error>{{ _lang("error.assignment-out-of-project-bounds") }}</mat-error>
				}
				@if (getOverlappingAssignment(row.effectiveUntil, row); as overlappingAssignment) {
					<mat-hint align="end" class="assignment-warning">
						{{ _lang("error.overlapping-assignment") }}<br />
						{{ overlappingAssignment.effectiveFrom | date: "dd.MM.yyyy" }}
						- {{ overlappingAssignment.effectiveUntil | date: "dd.MM.yyyy" }}
					</mat-hint>
				}
			</mat-form-field>
		</td>
	</ng-container>
	<ng-container matColumnDef="capacity">
		<th mat-header-cell mat-sort-header *matHeaderCellDef class="pe-0">{{ _lang("capacity") }}</th>
		<td id="capaCell" mat-cell *matCellDef="let row">
			<mat-form-field class="tableForm lessPadding">
				<input matInput appOnlyNumbers [formControl]="row.capacity" />
			</mat-form-field>
		</td>
	</ng-container>
	<tr mat-header-row *matHeaderRowDef="assignedEmployeesColumns; sticky: true"></tr>
	<tr mat-row *matRowDef="let row; columns: assignedEmployeesColumns"></tr>
</table>
